(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5535],{

/***/ 63829:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = 'M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.m6 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 90010:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'bag-shopping';
var width = 448;
var height = 512;
var aliases = ["shopping-bag"];
var unicode = 'f290';
var svgPathData = 'M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Cd = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 67157:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'minus';
var width = 448;
var height = 512;
var aliases = [8211,8722,10134,"subtract"];
var unicode = 'f068';
var svgPathData = 'M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Kl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 37518:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var aliases = [10133,61543,"add"];
var unicode = '2b';
var svgPathData = 'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.r8 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 83332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'share';
var width = 512;
var height = 512;
var aliases = ["arrow-turn-right","mail-forward"];
var unicode = 'f064';
var svgPathData = 'M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.zB = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 5503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageWithFallback; }
/* harmony export */ });
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);



function ImageWithFallback(_ref) {
  var src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      className = _ref.className,
      _ref$fallback = _ref.fallback;
  _ref$fallback = _ref$fallback === void 0 ? {} : _ref$fallback;
  var _ref$fallback$size = _ref$fallback.size,
      size = _ref$fallback$size === void 0 ? "640x16:9" : _ref$fallback$size,
      _ref$fallback$bg = _ref$fallback.bg,
      bg = _ref$fallback$bg === void 0 ? "eeeeee" : _ref$fallback$bg,
      _ref$fallback$color = _ref$fallback.color,
      color = _ref$fallback$color === void 0 ? "333333" : _ref$fallback$color,
      _ref$fallback$text = _ref$fallback.text,
      text = _ref$fallback$text === void 0 ? alt || "DaMaMaps" : _ref$fallback$text,
      fallbackSrc = _ref$fallback.src;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!src),
      error = _useState[0],
      setError = _useState[1];

  fallbackSrc = fallbackSrc || "https://dummyimage.com/".concat(size, "/").concat(bg, "/").concat(color, "&text=").concat(encodeURIComponent(text));
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    src: error ? fallbackSrc : src,
    layout: 'fill',
    alt: alt,
    className: className,
    onError: function onError() {
      return setError(true);
    }
  });
}

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84887);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62361);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44612);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57851);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);




var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function Rating(_ref) {
  var className = _ref.className,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
    icon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_5__/* .faStar */ .T
    }),
    emptyIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_regular_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_6__/* .faStar */ .T
    }),
    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)('text-primary text-sm shrink-0', className)
  }, props));
}

/***/ }),

/***/ 54613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Id; }
/* harmony export */ });
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faShare__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(83332);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faBagShopping__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90010);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faPlus__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37518);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faMinus__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67157);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faHeart__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(63829);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87607);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75046);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5503);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Rating__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41248);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57731);
/* harmony import */ var lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77078);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);






















var Title = function Title(props) {
  var children = props.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
    className: "font-bold",
    children: children
  });
};

var __N_SSP = true;
function Id(props) {
  var product = props.product;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var location = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (state) {
    return state.location.location;
  }, react_redux__WEBPACK_IMPORTED_MODULE_5__/* .shallowEqual */ .wU);
  var brands = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (state) {
    return state.brand.brands;
  }, react_redux__WEBPACK_IMPORTED_MODULE_5__/* .shallowEqual */ .wU);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(1),
      quantity = _useState[0],
      setQuantity = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(''),
      serviceBrand = _useState2[0],
      setServiceBrand = _useState2[1];

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    console.log('product: ', product);
    var brand = brands.find(function (item) {
      return item.id === product.brand_id;
    });

    if (brand !== undefined) {
      setServiceBrand(brand.name);
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (brands[0].name === 'Test') {
      var sort = {};
      var page = 1;
      var filter = {};
      dispatch((0,lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_8__/* .getPaginatedBrandsThunk */ .XZ)({
        page: page,
        filter: filter,
        sort: sort
      }));
    } else {
      var relativeBrand = brands.find(function (item) {
        return item.id === product.brand_id;
      });

      if (relativeBrand !== undefined) {
        setServiceBrand(relativeBrand);
      }
    }
  }, [brands]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      className: 'flex gap-8',
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
        className: "w-1/4 shrink-0",
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
          className: 'relative pb-[100%]',
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: product.images[0],
            alt: product.name,
            className: ' object-contain'
          })
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
        className: "flex-grow flex flex-col",
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
          className: "text-gray-500 text-sm",
          children: [serviceBrand.name !== '' ? "".concat(t("home:".concat(product.category)), " | By ") : t("home:".concat(product.category)), serviceBrand.name !== '' ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: "/brands/".concat(serviceBrand.slug, "/").concat(serviceBrand.id),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("a", {
              className: 'text-primary',
              children: serviceBrand.name
            })
          }) : null]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("h2", {
          className: "font-bold text-2xl mt-1 mb-2",
          children: product.name
        }), product.rating ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
          className: "mb-2 flex flex-nowrap items-center mb-4 text-gray-500",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "text-xs mr-2",
            children: product.rating.toFixed(1)
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(components_Rating__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: product.rating || 5,
            precision: 0.5,
            readOnly: true,
            className: 'mr-2'
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
            className: "text-xs",
            children: ["(", product.reviews_count, ")"]
          })]
        }) : null, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
          className: "self-start mb-3 rounded border overflow-hidden flex flex-nowrap items-center",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "w-10 h-10 relative",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              src: location.avatar_url,
              alt: location.name,
              className: 'object-cover'
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
            className: "text-sm pl-2 pr-4",
            children: [t('home:product_detail_page_pickupat'), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("span", {
              className: "text-gray-500",
              children: location.name
            })]
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
          className: "rounded border px-4 py-2 mb-3 self-start inline-block",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
            className: "flex mb-2",
            children: [product.price > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
              className: "font-bold text-xl",
              children: ["$", product.price_compare > 0 ? product.price_compare : product.price]
            }) : null, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
              className: "ml-2 text-gray-500 font-semibold line-through leading-normal",
              children: ["$", product.price_compare > 0 ? product.price : '']
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "text-sm text-gray-500",
            children: product.weight
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Title, {
          children: t('home:product_detail_quantity')
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          className: 'my-2 self-start',
          size: 'small',
          value: quantity,
          inputProps: {
            className: "text-center",
            inputMode: "numeric",
            pattern: '[0-9]*'
          },
          InputProps: {
            className: "p-0 w-[150px]",
            startAdornment: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              type: 'contain',
              className: "self-stretch !min-w-[40px]",
              onClick: function onClick() {
                return setQuantity(quantity - 1);
              },
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_pro_solid_svg_icons_faMinus__WEBPACK_IMPORTED_MODULE_14__/* .faMinus */ .Kl
              })
            }),
            endAdornment: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              type: 'contain',
              className: "self-stretch !min-w-[40px]",
              onClick: function onClick() {
                return setQuantity(quantity + 1);
              },
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_pro_solid_svg_icons_faPlus__WEBPACK_IMPORTED_MODULE_15__/* .faPlus */ .r8
              })
            })
          }
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          className: 'rounded-full self-start px-8 whitespace-nowrap',
          variant: 'outlined',
          size: 'small',
          children: [t('home:product_detail_addtocart'), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_pro_solid_svg_icons_faBagShopping__WEBPACK_IMPORTED_MODULE_16__/* .faBagShopping */ .Cd,
            className: 'ml-2'
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
          className: "mb-6"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Title, {
          children: t('home:service_detail_service_description')
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
          className: "mb-4"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("p", {
          className: "whitespace-pre-line",
          children: product.description
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
          className: "mb-6"
        }), product.strain ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Title, {
            children: "".concat(t('home:product_detail_aboutthisstrain'), ": ").concat(t('home:tba'))
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "mb-4"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("p", {
            className: "whitespace-pre-line",
            children: t('home:tba')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "mb-6"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Title, {
            children: t('home:product_detail_top_reported_strain_effects')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "mb-2"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("p", {
              className: "whitespace-pre-line",
              children: t('home:tba')
            }) // product.strain.effect ?
            //     product.strain.effects.map(effect => (
            //         <Chip
            //             key={effect.slug}
            //             className={"mr-2 mb-1 bg-primary text-white px-4"}
            //             size={'small'}
            //             label={effect.name}
            //         />
            //     )) : null

          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "mb-6"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Title, {
            children: t('home:product_detail_top_reported_strain_flavors')
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "mb-2"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("p", {
              className: "whitespace-pre-line",
              children: t('home:tba')
            }) // product.strain.flavours ?
            //     product.strain.flavours.map(flavour => (
            //         <Chip
            //             key={flavour.slug}
            //             className={"mr-2 mb-1 bg-yellow-500 text-white px-4"}
            //             size={'small'}
            //             label={flavour.name}
            //         />
            //     )) : null

          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("div", {
            className: "mb-6"
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)("div", {
            className: "flex",
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              variant: "outlined",
              className: "border-gray-400 text-gray-500 mr-3 hover:text-pink-500 hover:border-pink-400 hover:bg-pink-50",
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_pro_regular_svg_icons_faHeart__WEBPACK_IMPORTED_MODULE_17__/* .faHeart */ .m6,
                className: "mr-2 text-pink-500"
              }), t('home:product_detail_favorite')]
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              variant: "outlined",
              className: "border-gray-400 text-gray-500 hover:text-primary-dark",
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_pro_solid_svg_icons_faShare__WEBPACK_IMPORTED_MODULE_18__/* .faShare */ .zB,
                className: "mr-2"
              }), t('home:product_detail_share')]
            })]
          })]
        }) : null]
      })]
    })
  });
}

Id.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 77845:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/listing/[serviceSlug]/[id]",
      function () {
        return __webpack_require__(54613);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,2531,7607,9774,2888,179], function() { return __webpack_exec__(77845); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);